var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('common-button',{staticClass:"load-more mb-12",attrs:{"outlined":"","width":"240","loading":_vm.loading},on:{"click":function($event){return _vm.$emit('more')}}},[_vm._v(" Load more ("+_vm._s(_vm.size)+") ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }